import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';
import { RangeValidator } from '../../input/validator/range-validator';
import { GraphQLSignal } from '../../signal/graphql.signal';

@Component({
    selector: 'app-picker-meta',
    templateUrl: './picker-meta.component.html',
    styleUrls: ['./picker-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('picker-meta')
export class PickerMetaComponent {
    readonly graphqlSignal = inject(GraphQLSignal);
    model = input<any>();

    metaInterface: any = { id: 'interface', name: 'GraphQL Interface', info: 'Allowed GraphQL Interface for the picker', mandatory: true, label: 'name', value: '_id' };
    metaMin: any = { id: 'min', name: 'Minimum', info: 'Minimum items allowed' };
    metaMax: any = { id: 'max', name: 'Maximum', info: 'Maximum items allowed' };

    constructor() {

        effect(() => {
            const model = this.model();
            const graphqlTypes = this.graphqlSignal.types();

            if (model && graphqlTypes) {
                this.metaInterface.options = graphqlTypes;
                model.meta.formGroup.setValidators([RangeValidator()]);
            }
        });
    }
}
